import { INSTANCELIST, INSTANCE } from './API.js'

export const getProductCategories = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, range, filter, tabFilter } = queryKey[1]
    INSTANCELIST({
      method: 'get',
      url: '/product-categories/details',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort),
        range: JSON.stringify(range),
        filter: JSON.stringify(filter),
        ...tabFilter,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const getCategoryDetails = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { id } = queryKey[1]

    INSTANCE({
      method: 'get',
      url: `/product-categories/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const createCategory = (form) =>
  new Promise((resolve, reject) => {
    INSTANCELIST({
      method: 'post',
      url: '/product-categories',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject)
  })

export const updateCategory = (form, id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'put',
      url: `/product-categories/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject)
  })
